<template>
  <div
    class="progress-indicator"
    :class="{ 'progress-indicator--horizontal': horizontal, small: small }"
  >
    <div
      v-for="(step, idx) in steps"
      :key="idx"
      class="progress-indicator__step"
      :class="{
        'progress-indicator__step--completed':
          completed || idx + 1 < activeIndex,
        'progress-indicator__step--active':
          !completed && activeIndex === idx + 1,
      }"
      @click="handleStepperClick(step)"
    >
      <icon class-name="progress-indicator__step__icon" name="check" />
      {{ step.title }}
    </div>
  </div>
</template>

<script>
// Components
import Icon from "../Icon/Icon.vue";

export default {
  name: "ProgressIndicator",
  components: {
    Icon,
  },
  props: {
    /**
     * @description
     * The number of totat steps and details
     */
    steps: {
      type: Array,
      required: true,
    },
    /**
     * @description
     * The Active Step out of total steps e.g 3 of 5
     */
    activeIndex: {
      type: Number,
      required: true,
    },
    /**
     * @description
     * Checks if the all the steps are completed or not
     */
    completed: {
      type: Boolean,
      required: false,
    },
    /**
     * @description
     * Checks if progress indicator type should be small
     */
    small: {
      type: Boolean,
      default: false,
    },
    /**
     * @description
     * Checks if the Progress Indicator should be horizontal
     */
    horizontal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    handleStepperClick(step) {
      this.$emit("currentStepOnClickOfStepper", step);
    },
  },
};
</script>

<style lang="scss" scoped>
.progress-indicator.small {
  .progress-indicator__step {
    font-size: 14px;
  }
}
</style>
